import * as React from "react";
import { Path, G, Rect, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const FJIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="FJ" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#67BFE5"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <G clipPath="url(#b)">
        <Path fill="#2E42A5" d="M0 0h8.8v7.2H0z" />
        <Path
          fill="#F7FCFF"
          d="m-1.802 6.5 1.98.869L8.245.945 9.29-.346l-2.118-.29-3.29 2.768-2.649 1.865L-1.802 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m-1.531 7.108 1.009.505 9.436-8.08H7.498l-9.029 7.575Z"
        />
        <Path
          fill="#F7FCFF"
          d="M9.202 6.5 7.444 7.616-.845.944-1.89-.346l2.118-.29 3.29 2.768 2.649 1.865L9.202 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m9.135 6.937-1.01.504-4.018-3.46-1.19-.386L-1.99-.342h1.417L4.33 3.502l1.303.463 3.502 2.972Z"
        />
        <Path
          fill="#F50100"
          fillRule="evenodd"
          d="M4 0h-.8v3.2h-4V4h4v3.2H4V4h4v-.8H4V0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M2.45 0h2.3v2.45L8 2.4v2.3l-3.25.05V7.2h-2.3V4.75L-.8 4.7V2.4l3.25.05V0Zm.75 3.2h-4V4h4v3.2H4V4h4v-.8H4V0h-.8v3.2Z"
          clipRule="evenodd"
        />
      </G>
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M10 5h4.828v4.167S14.423 11 12.414 11C10.404 11 10 9.167 10 9.167V5Z"
        clipRule="evenodd"
      />
      <Mask
        id="c"
        width={5}
        height={6}
        x={10}
        y={5}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M10 5h4.828v4.167S14.423 11 12.414 11C10.404 11 10 9.167 10 9.167V5Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#c)">
        <Path fill="#C3352C" d="M10 5h4.828v1.5H10z" />
        <Path fill="#C3352C" d="M12.069 6.333h.69V11h-.69z" />
        <Path
          fill="#C3352C"
          fillRule="evenodd"
          d="M10 8.167h4.828v.666H10v-.666Z"
          clipRule="evenodd"
        />
        <Path
          fill="#979797"
          d="M11.695 9.29a.713.713 0 0 0 .086.018l.041.006c.134.02.176.032.223.089.09.108.03.207-.107.311-.151.116-.175.158-.171.189.01.023.007.083-.04.129l-.005.006c.04.067.107.163.204.286.167.033.156.204.038.374-.167.241-.404.08-.694-.33-.156-.206-.295-.318-.412-.342-.234-.047-.675-.44-.6-.653.048-.14.124-.142.426-.104l.02.003c.105.013.143.018.178.018.03 0-.102.052.21-.08.165-.07.316-.104.51-.098l.093.178Zm-.248.078a.941.941 0 0 0-.258.072c-.441.186-.222.1-.307.1-.05 0-.091-.005-.209-.02l-.02-.003c-.047-.006-.093-.009-.124-.017-.012-.012-.022-.021-.028-.029-.005-.007-.008-.013-.008-.015-.004.012-.002.02.004.028.007.007.018.012.032.016.083.086.294.264.377.28.19.039.375.187.566.441.194.274.286.336.287.334.037-.054.037.013.103.013l-.098-.047a2.898 2.898 0 0 1-.276-.39c-.07-.13-.08-.26.036-.297.02-.086.085-.174.214-.28a.444.444 0 0 1-.217-.076.196.196 0 0 1-.075-.11Zm.227.687a.133.133 0 0 1-.076.02.274.274 0 0 0 .07-.007l.006-.013Z"
        />
        <Path
          stroke="#964C36"
          strokeWidth={0.5}
          d="M10.828 8.055s-.239-.33-.239-.448"
        />
        <Path
          stroke="#2A8E51"
          strokeWidth={0.5}
          d="M10.68 7.771s-.306-.13-.306 0M10.674 7.634s-.214-.272-.375-.272c-.162 0-.158.136-.158.136M10.552 7.36s-.096-.445-.249-.445-.153.223-.153.223M10.59 7.36s-.042-.382.155-.382"
        />
        <Path
          stroke="#964C36"
          strokeWidth={0.5}
          d="M11.13 7.99s-.11-.391-.07-.502"
        />
        <Path
          stroke="#2A8E51"
          strokeWidth={0.5}
          d="M11.088 7.673s-.242-.226-.286-.104M11.13 7.543s-.108-.33-.26-.385c-.15-.055-.194.074-.194.074M11.11 7.244s.062-.452-.082-.505c-.144-.052-.22.158-.22.158M11.146 7.257s.09-.374.276-.307"
        />
        <Path
          stroke="#964C36"
          strokeWidth={0.4}
          d="M11.376 8.13s.158-.375.132-.49"
        />
        <Path
          stroke="#2A8E51"
          strokeWidth={0.4}
          d="M11.457 7.82s.268-.195.297-.068M11.43 7.686s.148-.314.305-.35c.158-.037.184.097.184.097M11.488 7.392s-.007-.457.143-.491c.149-.035.2.183.2.183M11.45 7.4s-.044-.383-.236-.338M13.349 7.901s.121-.557.465-.557c.345 0 .499.588.499.588"
        />
        <Path
          stroke="#2A8E51"
          strokeWidth={0.4}
          d="M13.065 7.52s.185-.328.797-.301c.612.027.723.302.723.302M12.941 7.103s.336-.417.807-.064l.16.064s.16-.472.933 0"
        />
        <Path
          stroke="#964C36"
          strokeWidth={0.5}
          d="M13.87 8.018s.024-.52.106-.662M14.55 9.157s-.31-.145-.402 0c-.093.145-1.207 1.48-1.207 1.48"
        />
        <Path
          fill="#FFF203"
          fillRule="evenodd"
          d="m13.482 9.298.69.482s.318-.226.16-.354c-.16-.128-.592-.354-.592-.354l-.258.226Z"
          clipRule="evenodd"
        />
        <Path
          fill="#00A651"
          fillRule="evenodd"
          d="M13.458 9.322s-.16.168-.16.296c0 .128-.149.47-.149.47s.417.257.503.094c.087-.164.648-.066.549-.315-.1-.25-.743-.545-.743-.545Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FFD100"
          fillRule="evenodd"
          d="M10.528 5.591s.369-.189.551 0c.183.19.332-.016.332-.13s.29-.505.29-.188c0 .318-.09.498.165.498.254 0 1.401-.44 1.676-.31.275.13.486.098.416-.088-.07-.187-.25-.303-.596-.201-.346.101-.264.2-.563.2-.3 0-.632-.099-.632-.099s.093-.167.435-.048c.341.119.812-.147.94-.147.128 0 .48-.008.515.094.035.101.248.195.086.29-.162.094-.43.153-.246.275.184.121.608.098.628.224.02.126.221.315.14.315-.08 0-.225.178-.36.124-.136-.054-.152-.102-.022-.146s.128-.228.021-.228-.055.064-.299 0c-.244-.065-.567-.137-.547 0 .02.136.178.346-.115.374-.293.028-.43.14-.487.05-.057-.09-.261-.211-.1-.25.16-.038.313.131.37.104.058-.028.189-.043.08-.16-.11-.118-.29-.187-.123-.275.167-.088.035-.09-.284.092-.32.182-.497.337-.777.315-.28-.022-.386.008-.476-.022-.09-.03-.528.326-.655.236-.126-.09-.534-.125-.46-.236.073-.11.171-.168.281-.11.11.056.22.113.293.056.074-.057.288-.253.234-.292-.054-.04-.002-.171-.306-.171s-.412.147-.484.054c-.072-.092.08-.2.08-.2Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
      <ClipPath id="b">
        <Path fill="#fff" d="M0 0h8.8v7.2H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
